"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const agent_1 = require("@dfinity/agent");
const jelly_hub_did_1 = require("../../declarations/jelly-hub-did");
const canisters_1 = require("../../config/canisters");
const parser = __importStar(require("./parser"));
const utils_1 = require("./utils");
class JellyHubService {
    constructor(agent) {
        this.getCollections = () => __awaiter(this, void 0, void 0, function* () {
            const response = yield this.actor.get_collections();
            return parser.getCollections.response(response);
        });
        this.addToListing = (params, collection) => __awaiter(this, void 0, void 0, function* () {
            const parsedParams = parser.addToListing.request(params, collection.id);
            const response = yield this.actor.make_listing(parsedParams);
            return parser.addToListing.response(response, collection);
        });
        this.removeFromListing = (params, collection) => __awaiter(this, void 0, void 0, function* () {
            const parsedParams = parser.removeFromListing.request(params, collection.id);
            const response = yield this.actor.cancel_listing(parsedParams);
            return parser.removeFromListing.response(response, collection);
        });
        this.buy = (params, collection) => __awaiter(this, void 0, void 0, function* () {
            const parsedParams = parser.buy.request(params, collection.id);
            const response = yield this.actor.direct_buy(parsedParams);
            return parser.buy.response(response, collection);
        });
        this.agent = agent;
        this.actor = agent_1.Actor.createActor(jelly_hub_did_1.idlFactory, {
            canisterId: (0, canisters_1.getJellyHubCanisterId)(),
            agent
        });
    }
    getPlugTransaction(collection, transaction, onSuccess = (res) => Promise.resolve(res), onFailure = () => Promise.resolve()) {
        const { methodParser, methodName } = utils_1.transactionMap[transaction.method];
        const plugOnSuccess = (res) => {
            // TODO: improve typing
            const parsedResponse = methodParser.response(res, collection);
            return onSuccess(parsedResponse);
        };
        return {
            idl: jelly_hub_did_1.idlFactory,
            canisterId: collection.marketplaceId.toText(),
            methodName,
            // I know the params type is correct because of JellyHubTransaction type
            args: [methodParser.request(transaction.params, collection.id)],
            onSuccess: plugOnSuccess,
            onFail: onFailure
        };
    }
}
exports.default = JellyHubService;
